"use client";

import { useState } from "react";
import { useCart } from "@/app/providers";

export default function AddToCartButton({ product, selectedWeight }) {
  const [cartStatus, setCartStatus] = useState("idle");
  const { addItem, isCartLoading } = useCart();
  const inStock = product.quantity > 0;

  async function handleClick() {
    setCartStatus("adding");
    try {
      await addItem(product);
      setCartStatus("added");
    } catch {
      setCartStatus("error");
    } finally {
      setTimeout(() => setCartStatus("idle"), 1600);
    }
  }

  return (
    <button
      onClick={handleClick}
      disabled={!inStock || isCartLoading || cartStatus === "adding"}
      className={`add-to-cart-btn${!inStock ? " add-to-cart-btn--disabled" : cartStatus === "added" ? " add-to-cart-btn--added" : ""}`}
    >
      {!inStock
        ? "Out of Stock"
        : cartStatus === "adding"
          ? "Adding…"
          : cartStatus === "added"
            ? "Added ✓"
            : cartStatus === "error"
              ? "Try again"
              : "Add to Cart"}
    </button>
  );
}
